<script>
export default {
  name: "InfiniteLoadingLoader"
}
</script>

<template>
  <div class="loader-holder">
<!--    <div class="label"><spring:message code="com.peoplepolitics.ui.news.loading.more"/></div>-->
    <div class="label">{{$t('common.loadingMore')}}</div>
    <div class="loading-animation">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 320 240" width="60" height="37" text-rendering="geometricPrecision" shape-rendering="geometricPrecision" style="white-space: pre;">
        <g id="Main" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(61,114.5)">
          <g id="Loading-more-NF-Dots" fill="#7835A6" transform="translate(-659.25,-902)">
            <path id="bubble-small-gif" d="M691.499,902C710.003,902,724.999,916.8,724.999,935.067C724.999,940.695,723.573,945.999,721.058,950.641C719,954.759,720.101,960.49,724.365,967.853L724.371,967.848C724.578,968.212,724.456,968.681,724.09,968.894C723.982,968.956,723.853,968.992,723.719,968.999C719.285,969.078,714.485,967.104,709.309,963.072C704.15,966.276,698.047,968.128,691.499,968.128C672.996,968.128,658,953.328,658,935.067C658,916.8,672.996,902,691.499,902Z" transform="translate(-39,-28.0005)" style="animation: 1s linear infinite both bubble-small-gif_t;"/>
            <path id="bubble-small-gif-2" d="M691.499,902C710.003,902,724.999,916.8,724.999,935.067C724.999,940.695,723.573,945.999,721.058,950.641C719,954.759,720.101,960.49,724.365,967.853L724.371,967.848C724.578,968.212,724.456,968.681,724.09,968.894C723.982,968.956,723.853,968.992,723.719,968.999C719.285,969.078,714.485,967.104,709.309,963.072C704.15,966.276,698.047,968.128,691.499,968.128C672.996,968.128,658,953.328,658,935.067C658,916.8,672.996,902,691.499,902Z" transform="translate(65.5005,-28.0005)" style="animation: 1s linear infinite both bubble-small-gif-2_t;"/>
            <path id="bubble-small-gif-3" d="M691.499,902C710.003,902,724.999,916.8,724.999,935.067C724.999,940.695,723.573,945.999,721.058,950.641C719,954.759,720.101,960.49,724.365,967.853L724.371,967.848C724.578,968.212,724.456,968.681,724.09,968.894C723.982,968.956,723.853,968.992,723.719,968.999C719.285,969.078,714.485,967.104,709.309,963.072C704.15,966.276,698.047,968.128,691.499,968.128C672.996,968.128,658,953.328,658,935.067C658,916.8,672.996,902,691.499,902Z" transform="translate(172.501,-28.0005)" style="animation: 1s linear infinite both bubble-small-gif-3_t;"/>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<style lang="scss">
.loader-holder {
  display: flex;
  align-items: center;
  justify-content: center;

  .label {
    color: #7835a6;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.3px;
    float: left;
    margin-right: 5px;
  }

  .loading-animation {
    float: left;
    position: relative;
    top: -3px;
    left: -5px;
  }
}

@keyframes bubble-small-gif_t { 0% { transform: translate(-39px,-28.000452px); } 40% { transform: translate(-39px,-28.000452px); } 70% { transform: translate(-39px,-61.501092px); } 100% { transform: translate(-39px,-29.153093px); } }
@keyframes bubble-small-gif-2_t { 0% { transform: translate(65.5005px,-28.000452px); } 20% { transform: translate(65.5005px,-28.000452px); } 50% { transform: translate(65.5005px,-63.08801px); } 80% { transform: translate(65.500504px,-27.999812px); } 100% { transform: translate(65.500504px,-27.999812px); } }
@keyframes bubble-small-gif-3_t { 0% { transform: translate(172.5005px,-28.000452px); } 30% { transform: translate(172.5005px,-61.934732px); } 60% { transform: translate(172.500504px,-27.999812px); } 100% { transform: translate(172.500504px,-27.999812px); } }
</style>